import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpCenterComponent } from './help-center.component';
import { RouterModule, Routes } from '@angular/router';
import { HeroModule } from '@app/core/components/hero/hero.module';
import { InfoBlockModule } from '@app/core/components/info-block/info-block.module';
import { ContactModule } from '@app/landing-page/components/contact/contact.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { CoreModule } from '@app/core/core.module';
import { HelpCardSlideModule } from '../components/help-card-slide/help-card-slide.module';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentMethodsModule } from '@app/landing-page/components/payment-methods/payment-methods.module';
import { HelpOptionsModule } from '@app/core/components/help-options/help-options.module';
import { VideoTutorialsModule } from '../components/video-tutorials/video-tutorials.module';
import { SystemsAlternativesModule } from '@app/landing-for-systems/components/systems-alternatives/systems-alternatives.module';
import { BlogBySystemModule } from '../../../landing-for-systems/components/blog-by-system/blog-by-system.module';
import { FaqQuestionsModule } from '../faq-questions/faq-questions.module';
import { FlyerSaldoModule } from '../../../landing-social-proof/components/flyer-saldo/flyer-saldo.module';

const routes: Routes = [
    {
        path: '',
        component: HelpCenterComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    declarations: []
})
export class HelpCenterRoutingModule {}

@NgModule({
    declarations: [HelpCenterComponent],
    exports: [HelpCenterComponent],
    imports: [
        CommonModule,
        HelpCenterRoutingModule,
        HeroModule,
        InfoBlockModule,
        CoreModule,
        HelpCardSlideModule,
        MatButtonModule,
        ContactModule,
        TranslateModule,
        PaymentMethodsModule,
        HelpOptionsModule,
        SystemsAlternativesModule,
        VideoTutorialsModule,
        BlogBySystemModule,
        FlyerSaldoModule,
        FaqQuestionsModule,
        VideoTutorialsModule
    ]
})
export class HelpCenterModule {}
